<template>
	<div class="mainApp">
		<DealsPage ref="deals_page" />
	</div>
</template>

<script>
	// @ is an alias to /src
	import DealsPage from "@/components/DealsPage.vue";

	export default {
		name: "NeighborhoodBuyView",
		components: {
			DealsPage,
		},
		data() {
			return {};
		},
		mounted() {
			var appVue = this;
			appVue.$store.state.loading = true;
			if (appVue.$store.state.config == null) {
				appVue.$store.dispatch("loadConfig");
			}
			//appVue.$store.dispatch("loadConfig").then(function () {
				appVue.$store.state.searchType = "NEIGHBORHOOD";
				appVue.$store.state.neighborhoodId = appVue.$route.query.id;
				appVue.$store.state.deals = [];
				appVue.mixin_fetchPageData(
					appVue,
					"NEIGHBORHOOD",
					appVue.$route.query.id,
					appVue.$store.state.config.api_base,
				);
				const d_url =
					appVue.$store.state.config.s3_page_base +
					"/neighborhood/buy/" +
					appVue.$route.query.id +
					".json";
				try {
					fetch(d_url).then(function (response) {
						if (!response.ok) {
							appVue.$router.push({
								name: "notfound",
								query: { view: "notfound" },
							});
						}
						const data = response.json();
						data.then(function (e) {
							if (appVue.$store.state.neighborhoodName == null) {
								appVue.$store.state.neighborhoodName = e.neighborhoodName;
							}
							if (appVue.$store.state.settlementName == null) {
								appVue.$store.state.settlementName = e.settlementName;
							}
							appVue.$store.state.similarNeighborhoods = e.otherNeighborhoods;
							appVue.$store.state.isMain = false;
							appVue.mixin_setTrendsData(appVue, e);
						});
					});
				} catch (error) {
					console.log("error", error);
					//send url to "?view=notfound"
					appVue.$router.push({
						name: "notfound",
						query: { view: "notfound" },
					});
				}
			//});
		},
	};
</script>
